<template>
<div
  class="input-group"
  v-if="loaded"
>
  <div
    class="input-group-prepend"
  >
    <div
      class="input-group-text"
    >
      <ItpIcon
        icon="material-symbols:repeat-rounded"
      >
      </ItpIcon>
    </div>
  </div>
  <ItpFormSelect
    name="billing_frequency"
    v-model="internalValue"
    :options="options"
    valueField="value"
    textField="name"
    required
    :readonly="readonly"
    @input="evh_5962862420439144_input($event, {})"
  >
  </ItpFormSelect>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class BillingFrequencySelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  value!: string;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  internalValue!: any;

  async $$load_internalValue() {
    return this.value
  }

  options!: any;

  async $$load_options() {
    return this.$app.repo.get('ui_metadata', { path: 'billing_frequency_options' })
  }

  ux!: any;
  dataMembers = ['internalValue', 'options', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        internalValue: null,
        options: null,
        ux: null,
      },
    }
  }

  async act_5962862420439144_emit_6636_getActionArgs($event: actions.ActionEvent): Promise<actions.EmitActionArgs> {
    // parameterResolver name=act_5962862420439144_emit_6636, alias=undefined
    return {
      event: "input",
      value: this.internalValue,
    }
  }

  async evh_5962862420439144_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5962862420439144_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5962862420439144_emit_6636: actions.EmitAction;
    evh_5962862420439144_input_6635: actions.EventHandlerImpl;
    evh_5962862420439144_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5962862420439144_emit_6636 = new actions.EmitAction(
      {
        actionArgs: this.act_5962862420439144_emit_6636_getActionArgs,
        events: [],
      }
    );
    const evh_5962862420439144_input_6635 = new actions.EventHandlerImpl(
      {
        action: act_5962862420439144_emit_6636,
        event: "input",
        displayName: "emit",
      }
    );
    const evh_5962862420439144_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5962862420439144_input_6635],
      }
    );
    return {
      act_5962862420439144_emit_6636,
      evh_5962862420439144_input_6635,
      evh_5962862420439144_input,
    }
  }
}

Vue.component("BillingFrequencySelector", BillingFrequencySelector);

</script>